import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/SiteHeader";
import { Brand } from "@/components/Brand";
import { Flag } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer className="border-t border-ff-border bg-ff-blue text-white">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-8 px-5 py-14 sm:px-8 md:grid-cols-4 lg:grid-cols-6">
        <div className="col-span-2 lg:col-span-2">
          <Logo light />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/70">
            Fast for donors. Strict for fundraisers. Controlled before payout. <Brand /> reviews
            campaigns and payout requests before funds are released.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/20 px-3 py-1.5 text-xs font-semibold text-white/80">
            <Flag className="h-3.5 w-3.5" /> Made in the USA · Managed by U.S. Citizens
          </div>
        </div>
        <FooterCol title="Platform" links={[
          ["How It Works", "/how-it-works"],
          ["Browse Fundraisers", "/browse"],
          ["Start a Fundraiser", "/start-a-fundraiser"],
        ]} />
        <FooterCol title="Trust" links={[
          ["Trust & Safety", "/trust-safety"],
          ["For Nonprofits", "/for-nonprofits"],
          ["Report a Campaign", "/report-campaign"],
        ]} />
        <FooterCol title="Company" links={[
          ["About", "/about"],
          ["FAQ", "/faq"],
          ["Contact", "/contact"],
          ["Sign In", "/sign-in"],
        ]} />
        <FooterCol title="Legal" links={[
          ["Terms of Service", "/terms"],
          ["Privacy Policy", "/privacy"],
          ["Cookie Policy", "/cookies"],
          ["Acceptable Use", "/acceptable-use"],
          ["Refund Policy", "/refund-policy"],
          ["Cookie preferences", null, () => window.dispatchEvent(new Event("ff:cookie-preferences"))],
        ]} />
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-start justify-between gap-2 px-5 py-6 text-xs text-white/50 sm:flex-row sm:items-center sm:px-8">
          <span>© {new Date().getFullYear()} <Brand /> Inc. USA Based · Only available in the USA · USD only.</span>
          <span data-testid="footer-fee-disclosure">5% platform fee (3% Pro) + Stripe processing fee on funds raised · Payments secured by Stripe.</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-white/90">{title}</h4>
      <ul className="mt-4 space-y-2.5">
        {links.map(([label, to, onClick]) => (
          <li key={label}>
            {onClick ? (
              <button
                type="button"
                onClick={onClick}
                data-testid="footer-cookie-preferences"
                className="text-left text-sm text-white/70 transition-colors duration-200 hover:text-white"
              >
                {label}
              </button>
            ) : (
              <Link to={to} className="text-sm text-white/70 transition-colors duration-200 hover:text-white">
                {label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
